export const SET_AUDIENCE_THEME = 'SET_AUDIENCE_THEME'
export const SET_AUDIENCE_TIMEFRAME = 'SET_AUDIENCE_TIMEFRAME'
export const SET_AUDIENCE_PODCAST = 'SET_AUDIENCE_PODCAST'
export const SET_AUDIENCE_PODCASTS = 'SET_AUDIENCE_PODCASTS'
export const SET_AUDIENCE_NETWORK = 'SET_AUDIENCE_NETWORK'
export const SET_AUDIENCE_NETWORKS = 'SET_AUDIENCE_NETWORKS'
export const SET_AUDIENCE_EPISODE = 'SET_AUDIENCE_EPISODE'
export const SET_AUDIENCE_EPISODES = 'SET_AUDIENCE_EPISODES'
export const SET_AUDIENCE_CAMPAIGN = 'SET_AUDIENCE_CAMPAIGN'
export const SET_AUDIENCE_FROM_LOCAL_STATE = 'SET_AUDIENCE_FROM_LOCAL_STATE'
export const CLEAR_API_CALLS = 'CLEAR_API_CALLS'
export const ADD_API_CALLS = 'ADD_API_CALLS'
